import type { LocItem } from '@/app/cc/_types/types';
import { createFetch } from '@/lib/cc/commonFetch';

interface LocListResponse {
  items: LocItem[];
}

export default async function getLocList(bjdCd: string) {
  const fetch = createFetch('town');
  const data = await fetch<LocListResponse>(`/regions`, {
    method: 'GET',
    params: {
      bjdCd,
    },
  });
  return data;
}
